import { render, staticRenderFns } from "./EnacAtplDashboardPhaseLearnerItems.vue?vue&type=template&id=27364ecc"
import script from "./EnacAtplDashboardPhaseLearnerItems.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardPhaseLearnerItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports